// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__CurrencyView from "../../../html/CurrencyView.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__FieldNumber from "../../../../util/FieldNumber.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import CloseSvg from "static/icons/close.svg";
import DeleteSvg from "static/icons/delete.svg";
import EditSvg from "static/icons/edit.svg";

function make(item) {
  return function (index) {
    return function (onSave) {
      return function (onDelete) {
        const match = React.useState(function () {
              return false;
            });
        const setIsDropdownShown = match[1];
        const isDropdownShown = match[0];
        const match$1 = React.useState(function () {
              return item.name;
            });
        const setName = match$1[1];
        const name = match$1[0];
        const match$2 = React.useState(function () {
              return Buhta_cabinet__FieldNumber.init(item.qty);
            });
        const setQty = match$2[1];
        const qty = match$2[0];
        const match$3 = React.useState(function () {
              return Buhta_cabinet__FieldNumber.init(item.item_price);
            });
        const setPrice = match$3[1];
        const price = match$3[0];
        const match$4 = React.useState(function () {
              return item.total_amount;
            });
        const setAmount = match$4[1];
        const amount = match$4[0];
        const resetValues = function (param) {
          Curry._1(setName, (function (param) {
                  return item.name;
                }));
          Curry._1(setQty, (function (param) {
                  return Buhta_cabinet__FieldNumber.init(item.qty);
                }));
          Curry._1(setAmount, (function (param) {
                  return item.total_amount;
                }));
          Curry._1(setPrice, (function (param) {
                  return Buhta_cabinet__FieldNumber.init(item.item_price);
                }));
        };
        React.useEffect((function () {
                Curry._1(setAmount, (function (param) {
                        return Belt__Belt_Option.getWithDefault(qty.value, 0) * Belt__Belt_Option.getWithDefault(price.value, 0);
                      }));
              }), [
              qty,
              price
            ]);
        React.useEffect((function () {
                resetValues(undefined);
              }), [isDropdownShown]);
        const saveItem = function (ev) {
          ev.stopPropagation();
          const saleItem_item_type = item.item_type;
          const saleItem_item_id = item.item_id;
          const saleItem_item_price = Belt__Belt_Option.getWithDefault(price.value, 0);
          const saleItem_qty = Belt__Belt_Option.getWithDefault(qty.value, 0);
          const saleItem = {
            item_type: saleItem_item_type,
            item_id: saleItem_item_id,
            name: name,
            item_price: saleItem_item_price,
            qty: saleItem_qty,
            total_amount: amount
          };
          Curry._2(onSave, saleItem, index);
          Curry._1(setName, (function (param) {
                  return name;
                }));
          Curry._1(setQty, (function (param) {
                  return Buhta_cabinet__FieldNumber.init(Belt__Belt_Option.getWithDefault(qty.value, 0));
                }));
          Curry._1(setAmount, (function (param) {
                  return amount;
                }));
          Curry._1(setPrice, (function (param) {
                  return Buhta_cabinet__FieldNumber.init(Belt__Belt_Option.getWithDefault(price.value, 0));
                }));
          Curry._1(setIsDropdownShown, (function (param) {
                  return false;
                }));
        };
        const priceText = price.text;
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsx("button", {
                            children: JsxRuntime.jsx(EditSvg, {}),
                            className: "ml-2",
                            onClick: (function (param) {
                                Curry._1(setIsDropdownShown, (function (param) {
                                        return true;
                                      }));
                              })
                          }),
                      isDropdownShown ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      className: "bg-black/80 h-100vh w-full"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                      className: "cart-dropdown--header",
                                                      children: "" + name + " - " + priceText
                                                    }),
                                                JsxRuntime.jsx("button", {
                                                      children: JsxRuntime.jsx(CloseSvg, {}),
                                                      onClick: (function (param) {
                                                          resetValues(undefined);
                                                          Curry._1(setIsDropdownShown, (function (param) {
                                                                  return false;
                                                                }));
                                                        })
                                                    })
                                              ],
                                              className: "flex justify-between items-center px-6 py-4 border-b"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Наименование",
                                                      type_: "text",
                                                      size: "m",
                                                      onChange: (function (value) {
                                                          Curry._1(setName, (function (param) {
                                                                  return value;
                                                                }));
                                                        }),
                                                      className: "mt-4",
                                                      value: name
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Количество",
                                                      type_: "text",
                                                      size: "m",
                                                      onChange: (function (value) {
                                                          Buhta_cabinet__FieldNumber.set(setQty, value);
                                                        }),
                                                      className: "mt-4",
                                                      value: qty.text
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                      label: "Цена",
                                                      type_: "text",
                                                      size: "m",
                                                      onChange: (function (value) {
                                                          Buhta_cabinet__FieldNumber.set(setPrice, value);
                                                        }),
                                                      className: "mt-4",
                                                      value: price.text
                                                    }),
                                                JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                                      size: "m",
                                                      className: "mt-4 bg-links",
                                                      isWide: true,
                                                      onClick: saveItem,
                                                      children: "Сохранить"
                                                    }),
                                                JsxRuntime.jsxs("button", {
                                                      children: [
                                                        JsxRuntime.jsx("img", {
                                                              className: "w-6 h-6",
                                                              src: StaticAsset.src("/static/icons/delete-red.svg")
                                                            }),
                                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                              className: "ml-2 text-alert",
                                                              children: "Удалить"
                                                            })
                                                      ],
                                                      className: "mt-4 flex items-center",
                                                      onClick: (function (param) {
                                                          Curry._1(onDelete, index);
                                                          Curry._1(setIsDropdownShown, (function (param) {
                                                                  return false;
                                                                }));
                                                        })
                                                    })
                                              ],
                                              className: "px-6 py-4"
                                            })
                                      ],
                                      className: "absolute bg-white bottom-0 rounded-t-2xl w-full"
                                    })
                              ],
                              className: "fixed inset-0 z-20"
                            }) : null
                    ]
                  });
      };
    };
  };
}

function CashboxCartMobile$EditItemDropdown(Props) {
  return Curry._2(make(Props.item)(Props.index), Props.onSave, Props.onDelete);
}

const EditItemDropdown = {
  make: CashboxCartMobile$EditItemDropdown
};

function make$1(item) {
  return function (index) {
    return function (onUpdateOpt) {
      const onUpdate = onUpdateOpt !== undefined ? onUpdateOpt : (function (param, param$1) {
            
          });
      return function (onDeleteOpt) {
        const onDelete = onDeleteOpt !== undefined ? onDeleteOpt : (function (param) {
              
            });
        return function (selectedOpt) {
          const selected = selectedOpt !== undefined ? selectedOpt : false;
          return function (onSelectOpt) {
            const onSelect = onSelectOpt !== undefined ? onSelectOpt : (function (param) {
                  
                });
            const qty = Stdlib.string_of_float(item.qty);
            const name = item.name;
            const price = item.item_price;
            const amount = item.total_amount;
            return JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                        isChecked: selected,
                                        className: "mr-4"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                className: "name",
                                                children: "" + name
                                              }),
                                          JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                className: "mt-1",
                                                children: [
                                                  JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                                        amount: price
                                                      }),
                                                  " x ",
                                                  JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                                                        className: "bg-warning rounded-11px px-1.5 py-0",
                                                        children: "" + qty + " " + "шт."
                                                      })
                                                ]
                                              })
                                        ],
                                        className: "grow mr-2"
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                        className: "total-price",
                                        children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                              amount: amount
                                            })
                                      })
                                ],
                                className: "flex items-center grow cursor-pointer",
                                onClick: (function (param) {
                                    Curry._1(onSelect, !selected);
                                  })
                              }),
                          JsxRuntime.jsx(CashboxCartMobile$EditItemDropdown, {
                                item: item,
                                index: index,
                                onSave: onUpdate,
                                onDelete: onDelete
                              })
                        ],
                        className: "flex gap-2 items-center py-3"
                      });
          };
        };
      };
    };
  };
}

function CashboxCartMobile$CartItemView(Props) {
  return Curry._4(make$1(Props.item)(Props.index), Props.onUpdate, Props.onDelete, Props.selected, Props.onSelect);
}

const CartItemView = {
  make: CashboxCartMobile$CartItemView
};

function make$2(items) {
  return function (onUpdate) {
    return function (onDelete) {
      return function (onDeleteAll) {
        return function (onSubmit) {
          const match = React.useState(function () {
                return false;
              });
          const setMax = match[1];
          const max = match[0];
          const match$1 = React.useState(function () {
                return /* [] */0;
              });
          const setSelectedItems = match$1[1];
          const selectedItems = match$1[0];
          const count = Stdlib__List.length(items);
          const sum = Belt__Belt_List.reduce(items, 0, (function (sum, item) {
                  return sum + item.total_amount;
                }));
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                      children: "Корзина"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        Stdlib__List.length(selectedItems) > 0 ? JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx(DeleteSvg, {}),
                                                onClick: (function (param) {
                                                    Curry._1(onDeleteAll, selectedItems);
                                                    Curry._1(setSelectedItems, (function (param) {
                                                            return /* [] */0;
                                                          }));
                                                  })
                                              }) : null,
                                        Stdlib__List.length(items) > 0 ? JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx("img", {
                                                      className: Cn.$plus("w-6 h-6", Cn.on("rotate-180", max)),
                                                      src: StaticAsset.src("/static/icons/arrow-up-black-24.svg")
                                                    }),
                                                onClick: (function (param) {
                                                    Curry._1(setMax, (function (param) {
                                                            return !max;
                                                          }));
                                                  })
                                              }) : null
                                      ],
                                      className: "flex gap-4"
                                    })
                              ],
                              className: "flex justify-between items-center"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: max ? JsxRuntime.jsx("div", {
                                              children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(items, (function (index, item) {
                                                          const Key = "cart-item-" + String(index);
                                                          return JsxRuntime.jsx(CashboxCartMobile$CartItemView, {
                                                                      item: item,
                                                                      index: index,
                                                                      onUpdate: onUpdate,
                                                                      onDelete: onDelete,
                                                                      selected: Belt__Belt_List.has(selectedItems, index, (function (item, param) {
                                                                              return item === index;
                                                                            })),
                                                                      onSelect: (function (selected) {
                                                                          if (selected) {
                                                                            return Curry._1(setSelectedItems, (function (param) {
                                                                                          return {
                                                                                                  hd: index,
                                                                                                  tl: selectedItems
                                                                                                };
                                                                                        }));
                                                                          } else {
                                                                            return Curry._1(setSelectedItems, (function (param) {
                                                                                          return Belt__Belt_List.keep(selectedItems, (function (item) {
                                                                                                        return item !== index;
                                                                                                      }));
                                                                                        }));
                                                                          }
                                                                        })
                                                                    }, Key);
                                                        }))),
                                              className: "grid pt-5"
                                            }) : null,
                                      className: "grow overflow-y-auto"
                                    }),
                                count > 0 ? JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        className: "text-default-gray",
                                                        children: String(count) + " товаров"
                                                      }),
                                                  JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                        children: Stdlib.string_of_float(sum) + " ₸"
                                                      })
                                                ],
                                                className: "flex justify-between items-center mt-1"
                                              }),
                                          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                                size: "m",
                                                className: "w-full mt-3",
                                                onClick: (function (param) {
                                                    Curry._1(onSubmit, undefined);
                                                  }),
                                                children: "Оплатить " + (Stdlib.string_of_float(sum) + " ₸")
                                              })
                                        ]
                                      }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: "mt-1 text-default-gray",
                                        children: "Добавьте товары или услуги со списка"
                                      })
                              ],
                              className: "flex flex-col grow"
                            })
                      ],
                      className: Cn.$plus("absolute bottom-0 bg-white rounded-t-2xl w-full px-6 py-3 flex flex-col", Cn.on("top-0", max))
                    });
        };
      };
    };
  };
}

function CashboxCartMobile(Props) {
  return Curry._3(make$2(Props.items)(Props.onUpdate), Props.onDelete, Props.onDeleteAll, Props.onSubmit);
}

const make$3 = CashboxCartMobile;

export {
  EditItemDropdown ,
  CartItemView ,
  make$3 as make,
}
/* Buhta_cabinet__Button Not a pure module */
